export default {
  NEED: '0',
  WANT: '1',
  LIKE: '2',
};
